import {commonActions} from '../../actions/commonActions';
import {fixtureSetList} from '../../actions/fixtureActions';
import {connect} from 'react-redux';
import List from '../../components/fixture/FixtureList';
import {API_FETCH} from '../../services/FetchService';



const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

const list = (value) => {
    return (dispatch, getState) => {
        API_FETCH.get('fixture',{params: value}).then(list => {
            dispatch(fixtureSetList(list.data.lists));
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.fixture.list,
        common       : state.common,
        initialValues: state.fixture.targetItem
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);